import service from './service'
import config from './config'
import { getLoginInfo } from '@/utils/CryptoJS'
import { useStorage } from '@/hooks/web/useStorage'

const { getStorage } = useStorage()

const { defaultHeaders } = config

const request = (option: AxiosConfig) => {
  const token = getLoginInfo(
    'token',
    /\/commodity\/|\/coupon\/|[?&]type=1/.test(location.href)
      ? 'clientId'
      : /\/column\//.test(location.href)
        ? 'columnId'
        : 'roomId'
  )
  const { url, method, params, data, headersType, responseType } = option
  return service.request({
    url: url,
    method,
    params,
    data,
    responseType: responseType,
    headers: {
      'Content-Type': headersType || defaultHeaders,
      'Token': token,
      'Encrypt': getStorage('encrypt')
    }
  })
}

/** 埋点数据 */
const pointRequest = (option: AxiosConfig) => {
  const token = getLoginInfo('token')
  const { url, method, params, data, headersType, responseType } = option
  return service.pointRequest({
    url: url,
    method,
    params,
    data,
    responseType: responseType,
    headers: {
      'Content-Type': headersType || defaultHeaders,
      'Token': token,
      'Encrypt': getStorage('encrypt')
    }
  })
}

export default {
  get: <T = any>(option: AxiosConfig) => {
    return request({ method: 'get', ...option }) as Promise<IResponse<T>>
  },
  post: <T = any>(option: AxiosConfig) => {
    return request({ method: 'post', ...option }) as Promise<IResponse<T>>
  },
  delete: <T = any>(option: AxiosConfig) => {
    return request({ method: 'delete', ...option }) as Promise<IResponse<T>>
  },
  put: <T = any>(option: AxiosConfig) => {
    return request({ method: 'put', ...option }) as Promise<IResponse<T>>
  },
  download: async <T = any>(option: any) => {
    const res = await request({ method: 'POST', responseType: 'blob', ...option })
    return res as unknown as Promise<T>
  },
  cancelRequest: (url: string | string[]) => {
    return service.cancelRequest(url)
  },
  cancelAllRequest: () => {
    return service.cancelAllRequest()
  },

  // 数据埋点
  point_post: <T = any>(option: AxiosConfig) => {
    return pointRequest({ method: 'post', ...option }) as Promise<IResponse<T>>
  }
}
